import React, { Component } from 'react';
import contactCardUtils from './ContactCardUtils';
import ContactCardComponent from './ContactCardComponent';
import Page from '../../../lib/page';
import { trackLink } from '../../../lib/analytics-helper';
import { contactChannels } from '../../../common/commonConstants';
import {
  isDeployedInGoPay,
  openCommunityExp,
  openMessageCenterExp,
  openResolutionCenterExp,
} from '../../../lib/globalHelper';
import i18n from '../../../lib/reacti18n';
import { elmoTreatmentNames, isPartOfElmoExpTreatment } from '../../../lib/experiments-helper';

class ContactCardContainer extends Component {
  static renderContactOptionCard() {
    const treatmentsAvailable = Page.elmoTreatments();
    const isPartOfMCVerbiageTreatment = isPartOfElmoExpTreatment(
      treatmentsAvailable,
      elmoTreatmentNames.messageCenterContactCardExp,
    );
    return contactCardUtils.map((contactDetails) => {
      /* eslint-disable no-param-reassign */
      if (isPartOfMCVerbiageTreatment && contactDetails.contactType === contactChannels.MESSAGE_CENTER) {
        // change the message center contact card description for the user part of the message center verbiage treatment
        contactDetails.contactDescription = i18n.message('smarthelp/contactLinksOption.message.contactCardLabel');
      }

      if (contactDetails.contactType === contactChannels.COMMUNITY && isDeployedInGoPay()) {
        contactDetails.contactDisplay = false;
      }

      const commonProps = {
        contactType: contactDetails.contactType,
        contactLabel: contactDetails.contactLabel,
        contactDescription: contactDetails.contactDescription,
        contactTarget: contactDetails.contactTarget,
        contactUrl: contactDetails.contactUrl,
        contactSize: contactDetails.contactSize,
      };
      return contactDetails.contactDisplay ? <ContactCardComponent {...commonProps} /> : null;
    });
  }

  // Contact card option click function
  static clickHandler(e, contactOption) {
    e.preventDefault();
    if (contactOption.contactType) {
      // FPTI Click event when clicked on contact card
      trackLink({ id: Page.getFPTIPageId(), link: `smarthelp-hero-links|${contactOption.contactType}` });
    }
    switch (contactOption.contactType) {
      case contactChannels.RESOLUTION:
        return openResolutionCenterExp(contactOption.contactTarget);
      case contactChannels.COMMUNITY:
        return openCommunityExp(contactOption);
      case contactChannels.MESSAGE_CENTER:
        return openMessageCenterExp(contactOption.contactTarget);
      default:
        return <div />;
    }
  }

  // check for elmo treatment
  render() {
    return <div className="contact-option-cards">{ContactCardContainer.renderContactOptionCard()}</div>;
  }
}

export default ContactCardContainer;
